// @ts-nocheck
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from 'react-bootstrap';
import BuilderRequest from '../../../../Ame/Requests/BuilderRequest/BuilderRequest';
import Loading from '../../../../../components/Shared/Loader/Loading';
import CustomAlert from '../../../../../components/Shared/Alert/CustomAlert';
import useGetFormColumn from '../../../../../hooks/Forms/use-get-FColumn';
import useAddRequest from '../../../../Ame/Requests/useAddRequest';
import StaticForm from '../../../../Ame/Requests/StaticForm';
import { useAppSelector } from '@store/hooks';
import { getPersonId } from '@store/Login2/authSelectors';

const AddRequests = ({ FormId, onBack }) => {
  const { t, i18n } = useTranslation();
  const personId = useAppSelector(getPersonId); // Get the person ID from the Redux store

  const [referenceId, setReferenceId] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { FormColumnList, loading, error } = useGetFormColumn(FormId);
  const [formData, setFormData] = useState({});
  const { AddRequest } = useAddRequest();

  // Check if personId is not available
  if (!personId) {
    return (
      <div className='text-center p-4'>
        <div className='alert alert-warning d-flex align-items-center justify-content-center' role='alert'>
          <i className='bi bi-exclamation-triangle-fill me-2 fs-4'></i>
          <span>
            {i18n.language === 'en'
              ? 'This feature is restricted to employee accounts. Please contact support.'
              : 'هذه الميزة مقتصرة على حسابات الموظفين. يرجى التواصل مع الدعم.'}
          </span>
        </div>
        <button type='button' className='btn btn-outline-secondary rounded-1' onClick={() => onBack()}>
          <i className='fa fa-arrow-left fa-fw me-1'></i>
          {t('Back')}
        </button>
      </div>
    );
  }

  const handleAddRequest = async e => {
    if (e) {
      e.preventDefault();
    }

    const RequestData = {
      selectedPersonId: '',
      isPersonaly: true,
      referenceId: referenceId || '',
      dynamicFormId: FormColumnList?.dynamicFormId,
      values: FormColumnList?.columnList
        ?.filter(f => f.enabledFlag === true)
        ?.map(item => ({
          dynamicFormColumnID: item.id,
          dataType: item.validationType || item.formatType,

          value:
            item.validationType === 'BOOLEAN' && !formData[item.id]
              ? '0'
              : item.validationType === 'ATTACHED'
              ? null
              : formData[item.id],

          lableText: i18n.language === 'ar' ? item.lable2 : item.lable,
          lableText2: i18n.language === 'ar' ? item.lable2 : item.lable,
          sequenceNum: item.sequenceNum,
          fileAttachment: item.validationType === 'ATTACHED' && formData[item.id] ? formData[item.id] : null,
          isUpdateAttach: item.validationType === 'ATTACHED' && formData[item.id] ? true : false
        }))
    };

    setIsSubmitting(true);

    var respons = await AddRequest(RequestData);
    if (respons?.succeeded === true) {
      onBack();
      CustomAlert({ action: 'Add', msg: 'تم ارسال الطلب بنجاح' });
    } else {
      CustomAlert({ action: 'Info', msg: respons?.message });
    }
    setIsSubmitting(false);
  };

  useEffect(() => {
    if (referenceId !== null) {
      handleAddRequest();
    }
  }, [referenceId]);

  //________________________________

  console.log(personId);

  return (
    <>
      <Loading loading={loading} error={error}>
        <div className='text-center bg-inverse bg-opacity-10 rounded-0 p-2 fw-bold mb-2 text-theme d-flex justify-content-between align-items-center'>
          <span className='fs-5'>
            {i18n.language === 'en' ? FormColumnList.dynamicFormName : FormColumnList.dynamicFormName2}
          </span>

          <button type='button' className='btn btn-sm btn-outline-default rounded-1 ms-2' onClick={() => onBack()}>
            <i className='fa fa-arrow-left fa-fw me-1'></i>
            {t('Back')}
          </button>
        </div>
        <Form onSubmit={handleAddRequest}>
          {FormColumnList?.isStatic && (
            <StaticForm StaticFormId={FormColumnList.dynamicFormId} setReferenceId={setReferenceId} />
          )}
          {FormColumnList?.dynamicFormId && (
            <BuilderRequest FormColumnList={FormColumnList} setFormData={setFormData} formData={formData} />
          )}

          {!FormColumnList?.isStatic && (
            <div className='text-center d-flex mt-3'>
              <button
                disabled={isSubmitting}
                type='submit'
                className='btn btn-lg me-1 btn-outline-theme rounded-1 w-100'
              >
                {isSubmitting ? (
                  <div className='spinner-border spinner-border-sm me-2'></div>
                ) : (
                  <i className='bi bi-send fa-fw me-1'></i>
                )}
                {t('SendRequest')}
              </button>
            </div>
          )}
        </Form>
      </Loading>
    </>
  );
};

export default AddRequests;
